module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r8n5r1r-2b74386ce397bbad24b37286b44aa3c3.svg";